import React, { useContext } from "react";
import useTranslation from "../../../hooks/useTranslation";
import { useSimCardManagement } from "../../../hooks/productManagement";
import FeaturePageLayout from "../../Shared/FeaturePageLayout/FeaturePageLayout";
import FeatureHeader from "../../Shared/FeaturePageLayout/FeatureHeader/FeatureHeader";
import FeatureTable from "../../Shared/FeaturePageLayout/FeatureTable/FeatureTable";
import FeaturePagination from "../../Shared/FeaturePageLayout/FeaturePagination/FeaturePagination";
import AddSimCardModal from "./AddSimCardModal/AddSimCardModal";
import EditSimCardModal from "./EditSimCardModal/EditSimCardModal";
import ConfirmationModal from "../../Shared/ConfirmationModal/ConfirmationModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "../../../helpers/icons/fontAwesomeIcons";
import UserContext from "../../../context/UserContext";
import USER_ROLES from "../../../constants/userRoles";

const SimCardsSection = () => {
  const { t } = useTranslation("productManagerPage");
  const { user } = useContext(UserContext);
  const isSuperAdmin = user && user.roles === USER_ROLES.SUPER_ADMIN;
  const {
    // State
    setSearchTerm,
    showAddModal,
    setShowAddModal,
    showEditModal,
    setShowEditModal,
    selectedSimCard,
    showDeleteConfirmation,
    simCardToDelete,
    filteredSimCards,
    recordsPerPage,
    setRecordsPerPage,
    currentPage,
    setCurrentPage,
    loadingSimCards,
    paginatedSimCards,

    // Functions
    handleAddSimCard,
    handleSaveSimCard,
    handleUpdateSimCard,
    handleConfirmDelete,
    handleCancelDelete,
    handleActionClick,
    //applyFilters,
  } = useSimCardManagement();

  const simCardColumns = [
    {
      key: "sim",
      label: t("sim"),
      render: (row) => row?.sim || "-",
    },
    {
      key: "phonenumber",
      label: t("phoneNumber"),
      render: (row) => row?.phonenumber || "-",
    },
    {
      key: "pin",
      label: t("pin"),
      render: (row) => row?.pin || "-",
    },
    {
      key: "pin2",
      label: t("pin2"),
      render: (row) => row?.pin2 || "-",
    },
    {
      key: "puk",
      label: t("puk"),
      render: (row) => row?.puk || "-",
    },
    {
      key: "puk2",
      label: t("puk2"),
      render: (row) => row?.puk2 || "-",
    },
    {
      key: "cardname",
      label: t("card_name"),
      render: (row) => row?.cardname || "-",
    },
  ];

  const selectors = [];

  return (
    <>
      <FeaturePageLayout>
        <FeatureHeader
          t={t}
          title={t("simCards")}
          search={setSearchTerm}
          selectors={selectors}
          display={{
            count: recordsPerPage,
            onChange: setRecordsPerPage,
            options: [5, 10, 20, 50],
          }}
          actionButton={
            isSuperAdmin
              ? {
                  onClick: handleAddSimCard,
                  icon: <FontAwesomeIcon icon={faPlus} />,
                  label: "add_sim_card",
                }
              : null
          }
        />
        {/* Render simcard table or list here */}
        <FeatureTable
          t={t}
          data={paginatedSimCards || []}
          columns={simCardColumns}
          tableType="simCards"
          pagination={null}
          loading={loadingSimCards}
          actions={{
            view: true,
            edit: true,
            delete: true,
            custom: [],
          }}
          onActionClick={handleActionClick}
        />
      </FeaturePageLayout>
      {filteredSimCards && filteredSimCards.length > 0 ? ( // ✅ Added null check
        <div className="pagination-container">
          <FeaturePagination
            t={t}
            currentPage={currentPage}
            totalPages={Math.ceil(
              (filteredSimCards?.length || 0) / recordsPerPage
            )}
            onPageChange={setCurrentPage}
          />
        </div>
      ) : (
        <div className="no-data-message">{t("no_sim_cards_found")}</div>
      )}

      {/* Modals for adding, editing and deleting products */}
      <AddSimCardModal
        t={t}
        show={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSave={handleSaveSimCard}
        tableType="simCards"
      />

      <EditSimCardModal
        t={t}
        show={showEditModal}
        onClose={() => setShowEditModal(false)}
        simCard={selectedSimCard}
        onSave={handleUpdateSimCard}
      />

      <ConfirmationModal
        isVisible={showDeleteConfirmation}
        onConfirm={() => handleConfirmDelete(simCardToDelete)}
        onCancel={handleCancelDelete}
        message={
          simCardToDelete
            ? t("confirm_delete_sim_card", {
                sim: simCardToDelete.sim,
              })
            : ""
        }
      />
    </>
  );
};

export default SimCardsSection;
